import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    // debug: true,
    resources: {
      'en-US': {
        translation: {
          'Personal Strategies': 'Personal Strategies',
          'performance': 'Performance',
          'performance-desc': 'Avg Annual Returns over Common Period (%)',
          'performance-tooltip': 'Common period is from [[FROM]] to [[TO]].',
          'income': 'Income', 
          'income-desc': 'Trailing 12M Dividend Yields (%)',     
          'income-tooltip': 'As of [[ASOF]].',    
          'risk': 'Risk',     
          'risk-desc': 'Avg Annual Volatility over Common Period (%)', 
          'risk-tooltip': 'Common period is from [[FROM]] to [[TO]].',
          'sharpe': 'Risk Adj. Returns',
          'sharpe-desc': 'Avg Annual Sharpe Ratio over Common Period',
          'sharpe-tooltip': 'Common period is from [[FROM]] to [[TO]].',
          'fees': 'Fees',       
          'fees-desc': 'Expense Ratio (bps)',   
          'fees-tooltip': 'Expense ratio is the sum-product of weights and expenses of individual funds in each portfolio. Ordinary brokerage commissions may apply.',
          'key-metrics-title': 'Key Metrics',
          'key-metrics-footnote': 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor\'s shares, when redeemed, may be worth more or less than their original cost.The most recent month end performance for underlying funds can be found on the individual funds\' website. For this and other important information please click on the fund\'s ticker symbol above. In addition, details regarding the underlying funds 30-Day SEC Yield can be found in the Fund Details section of this document.',
          'number-of-holdings': 'Number of holdings',
          'holdings' : 'Composition',
          'click-to-edit-holdings-tooltip' : 'Click on a fund to open in our Fund Comparison tool',
          'growth' : 'Growth',
          'hypothetical-growth-title-orig': 'Hypothetical Growth of $1M allocation ([[FROM]] to [[TO]])',
          'hypothetical-growth-title': 'Hypothetical Growth of $1M allocation',
          'hypothetical-growth-footnote': 'The hypothetical growth chart illustrates total calendar year returns of the hypothetical portfolio you have modeled made on the start date shown. The most recent calendar year will only reflect year-to-date data and may not display return information for a full calendar year.',
        },
      },
      'en-GB': {
        translation: {
          'Personal Strategies': 'Personal Strategies',
        }
      },
    },
  });

export default i18n;